import { useNavigate } from 'react-router-dom';
import './FloatButton.css';

export const FloatButton = (props) => {
  const { cdn, type } = props;
  const navigate = useNavigate();

  const navTo = () => {
    if (type === 'back' || type === 'collapse') {
      navigate(-1);
    } else if (type === 'info') {
      navigate('/info');
    }
  };

  return (
    <div className={`float-btn float-btn--${type}`} onClick={navTo}>
      <img
        className="float-btn__img"
        alt={`${type} icon`}
        src={`${cdn}pictos/float-btn/float-btn-${type}.svg`}
      />
    </div>
  );
};
